import { useMutation, useQuery } from 'react-query';
import { SkillScoringParameterService } from '@api/SkillScoringParameterService';
import { onDefaultError } from '../helpers/commonHelpers';

// List Skill Scoring Parameters
const useListSkillScoringParameters = ([page_no, searchText, status], onSuccess, onError = onDefaultError) => {
  return useQuery(
    ['skill-scoring-parameters-list', page_no, searchText, status],
    SkillScoringParameterService.listSkillScoringParameters,
    {
      onSuccess,
      keepPreviousData: true,
      onError
    }
  );
};


// Add Skill Scoring Parameter
const useAddSkillScoringParameters = (onSuccess, onError = onDefaultError) => {
  return useMutation(SkillScoringParameterService.addSkillScoringParameter, {
    onSuccess,
    onError
  });
};

// Update Skill Scoring Parameter
const useUpdateSkillScoringParameters = (onSuccess, onError = onDefaultError) => {
  return useMutation(SkillScoringParameterService.updateSkillScoringParameter, {
    onSuccess,
    onError
  });
};

// Delete Skill Scoring Parameter
const useDeleteSkillScoringParameters = (onSuccess, onError = onDefaultError) => {
  return useMutation(SkillScoringParameterService.deleteSkillScoringParameter, {
    onSuccess,
    onError
  });
};

// View Skill Scoring Parameter
const useViewSkillScoringParameters = (id, onSuccess, onError = onDefaultError) => {
  return useQuery(['skill-scoring-parameter-view', id], () =>
    SkillScoringParameterService.viewSkillScoringParameter(id),
    {
      onSuccess,
      onError
    }
  );
};

const useStatusChangeSkillScoringParameters = (onSuccess, onError = onDefaultError) => {
  return useMutation(SkillScoringParameterService.statusChangeSkillScoringParameter, {
    onSuccess,
    onError
  });
};

const useGetSkillParameterDropdown = (onSuccess, onError = onDefaultError) => {
  return useQuery('parameter-list', SkillScoringParameterService.getFaqCategory, {
    onSuccess,
    onError
  });
};

const useGetSkillOptionDropdown = (onSuccess, onError = onDefaultError) => {
  return useQuery('parameter-list', SkillScoringParameterService.getFaqCategory, {
    onSuccess,
    onError
  });
};


export {
  useListSkillScoringParameters,
  useAddSkillScoringParameters,
  useViewSkillScoringParameters,
  useUpdateSkillScoringParameters,
  useDeleteSkillScoringParameters,
  useStatusChangeSkillScoringParameters
};